import React, { useState } from 'react';
import { DKLabel, DKButton, DKIcons, DKIcon, showAlert } from 'deskera-ui-library';
import Popup from './common/Popup';
import PasswordInput from './common/PasswordInput';
import { changePassword } from '../services/auth';
import { useAppSelector } from '../store/hooks';
import { selectTenantSettings } from '../store/slices/authSlice';
import { DEFAULT_THEME_COLOR } from '../constants/Constant';

interface IChangePasswordProps {
  onClose: () => void;
}

const ChangePassword: React.FC<IChangePasswordProps> = ({ onClose }) => {
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [canValidate, setCanValidate] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const settings = useAppSelector(selectTenantSettings);

  const isFormValid = () => {
    return (
      oldPassword.trim().length > 0 &&
      newPassword.trim().length > 0 &&
      confirmPassword.trim().length > 0
    );
  };

  const onSubmit = () => {
    setCanValidate(true);
    if (!isFormValid()) return;
    if (newPassword !== confirmPassword) {
      showAlert('Password Mismatch', 'New password and confirm password do not match.');
      return;
    }
    setSubmitting(true);
    changePassword({ oldPassword, newPassword })
      .then(() => {
        showAlert('Success', 'Password changed successfully.');
        onClose();
      })
      .catch(() => {
        showAlert('Error', 'Failed to change password. Please check your current password and try again.');
      })
      .finally(() => setSubmitting(false));
  };

  return (
    <Popup title="Change Password" allowClose onClose={onClose} popupWindowStyles={{ width: 400 }}>
      <PasswordInput
        title="Current Password"
        className="mt-l"
        autoComplete="current-password"
        value={oldPassword}
        canValidate={canValidate}
        onChange={(text: string) => setOldPassword(text)}
      />
      <PasswordInput
        title="New Password"
        className="mt-l"
        value={newPassword}
        canValidate={canValidate}
        onChange={(text: string) => setNewPassword(text)}
      />
      <PasswordInput
        title="Confirm New Password"
        className="mt-l"
        value={confirmPassword}
        canValidate={canValidate}
        onChange={(text: string) => setConfirmPassword(text)}
      />
      <div className="row justify-content-end mt-xl">
        <DKButton
          title="Cancel"
          className="bg-gray2 border-m mr-r"
          onClick={onClose}
        />
        <div
          className={
            'column align-items-center text-white border-radius-s p-r fw-m ' +
            (submitting ? '' : 'cursor-hand')
          }
          style={{
            backgroundColor: settings?.theme || DEFAULT_THEME_COLOR,
            padding: '6px 16px'
          }}
          onClick={!submitting ? onSubmit : undefined}
        >
          <DKLabel text={submitting ? 'Saving...' : 'Save'} />
        </div>
      </div>
    </Popup>
  );
};

export default ChangePassword;
